module.exports = __webpack_public_path__ + "static/media/preview3-large.63aa04a4.jpg";